import { Page } from '@/core/architecture'

import { ArtistGachasTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ArtistGachas Page
 * Implemented as a practical sample.
 */
export const ArtistGachas: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <ArtistGachasTemplate state={state} onFetchMore={actions.onFetchMore} />
  )
}
